import { memo } from 'react';
import { Table as TableMaterial, TableContainer } from '@mui/material';
import TableHead from './table-head';
import TableBody from './table-body';
import { HeadCell } from './types';

interface TableProps<T, K extends keyof T> {
  head: Array<HeadCell<T, K>>;
  body: Array<T>;
  ariaLabel: string;
  minWidth?: number;
  isFixed?: boolean;
}

const TableComponent = <T, K extends keyof T>({
  head,
  body,
  ariaLabel,
  minWidth = 900,
  isFixed = true,
}: TableProps<T, K>) => {
  return (
    <TableContainer>
      <TableMaterial
        sx={{ minWidth }}
        size="medium"
        stickyHeader
        aria-label={ariaLabel}
        style={{ tableLayout: isFixed ? 'fixed' : 'auto' }}
      >
        <TableHead head={head} />
        <TableBody body={body} head={head} />
      </TableMaterial>
    </TableContainer>
  );
};

TableComponent.displayName = 'Table Component';

const Table = memo(TableComponent);

export default Table as unknown as typeof TableComponent;
